import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Optional, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ReplaySubject, Subject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
import { ApplicationType, SearchEntity } from 'src/app/core/constants/dropdown-contants';
import { filteredParams } from 'src/app/core/helpers/helperfunc';
import { ApplicationStatusService } from 'src/app/core/services/application-status/application-status.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { UniversityService } from 'src/app/core/services/university/university.service';

@Component({
  selector: 'app-cams-id-search',
  templateUrl: './cams-id-search.component.html',
  styleUrls: ['./cams-id-search.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatCardModule, MatInputModule, MatSelectModule, MatSelectInfiniteScrollModule, NgxMatSelectSearchModule, MatButtonModule, MatDialogModule]
})
export class CamsIdSearchComponent implements OnInit, OnDestroy {
  @Input() isModal: boolean = false; // New input property to determine modal mode
  @Input() showAssignButton: boolean = true;
  cams_search_form: FormGroup;
  university: any;
  university_name: any[] = [];
  public university_filter: FormControl<string> = new FormControl<string>('');
  public filtered_university: ReplaySubject<any> = new ReplaySubject<any>(1);
  university_pagination = {
    skip: 0,
    limit: 10
  };
  total_university_count: number = 0;
  university_offset: number = 0;
  search_university: string = '';
  university_counter: number = 0;
  search_entiry = SearchEntity;
  private _unsubscribeAll: Subject<any> = new Subject();
  @Output() applyFilter: EventEmitter<any> = new EventEmitter()

  constructor(
    @Optional() public dialogRef: MatDialogRef<CamsIdSearchComponent>, // Optional dialog reference
    private _loaderService: LoaderService,
    private _fb: FormBuilder,
    private _universityService: UniversityService
  ) { }

  ngOnInit(): void {
    this.isModal = !!this.dialogRef;
    this.initiateForm();
    this.getUniversity();
    this.filterUniversity();
  }

  initiateForm() {
    this.cams_search_form = this._fb.group({
      applicationId: [''],
      studentName: [''],
      studentId: [''],
      universityId: [''],
      studentEmailId: [''],
    });
  }

  close(value?: any) {
    if (this.isModal && this.dialogRef) {
      this.dialogRef.close(value);
    }
  }

  getUniversity() {
    this._loaderService.showLoader();
    this._universityService.getUniversity(this.university_pagination, '', '', this.search_university)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((res) => {
        let university = res?.data;
        this.university = university?.data?.map((v) => { return ({ id: v.id, name: v.name }) });
        this.total_university_count = university?.data?.total;
        this._loaderService.hideLoader();
      }, (err) => {
        this._loaderService.hideLoader();
      });
  }

  filterUniversity() {
    this.university_filter.valueChanges
      .pipe(
        debounceTime(this.search_entiry.debounce_time),
        distinctUntilChanged(),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe((res: string) => {
        this.search_university = res;
        this.getUniversity();
      });
  }

  getNextUniversity() {
    this.university_pagination.skip = 0;
    this.university_pagination.limit += 10;
    this.university_offset += this.university_pagination.limit;
    this.getUniversity();
  }

  search() {
    let applied_filters = filteredParams(this.cams_search_form.value);
    let mapped_filter = '';
    if (applied_filters.length) {
      applied_filters.forEach(element => {
        Object.keys(element).forEach(key => {
          mapped_filter += `${key}=${element[key]}&`;
        });
      });
    }
    if (this.isModal) {
      this.close(mapped_filter);
    } else {
      console.log('Filters applied:', mapped_filter);
      this.applyFilter.emit(mapped_filter);
    }
  }

  resetForm(){
    Object.keys(this.cams_search_form.controls).forEach(key => {
      this.cams_search_form.get(key)?.setValue('');
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
